import { render, staticRenderFns } from "./AddCreditModal.vue?vue&type=template&id=22dda200&"
import script from "./AddCreditModal.vue?vue&type=script&lang=js&"
export * from "./AddCreditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports